import React from "react";
import { Stack, useBreakpointValue, useColorModeValue, Box } from "@chakra-ui/react";
import { BlockSectionHeader } from "screens/content/contentView/previewSection/BlockSectionHeader";
import { SectionFooter } from "./SectionFooter";

interface SectionWrapperProps {
  children?: React.ReactNode;
  title?: string;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, title }) => {
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const bgColor = useColorModeValue("white", "#161B25");

  return (
    <Box width="100%" bg={bgColor} border="1px solid" borderColor={borderColor} borderRadius="md">
      <Stack pt={isMobile ? ".5rem" : "1rem"} pb={isMobile ? "0" : ".5rem"}>
        {title && <BlockSectionHeader style={{ paddingLeft: isMobile ? ".5rem" : "1rem" }} title={title} />}
        {children}
      </Stack>
      <SectionFooter />
    </Box>
  );
};
